import { useEffect } from 'react';
import analytics from 'service/analytics';
import styles from './index.module.sass';
import { CHANGE_CURRENT_PAGE, PAGE_COUPON, useAppContext } from 'use-app';
import { CouponContent } from './coupon-content';

const Coupon = () => {
  const { dispatch: appDispatch } = useAppContext();

  useEffect(() => {
    analytics.couponPageView();
  }, []);

  useEffect(() => {
    appDispatch({
      type: CHANGE_CURRENT_PAGE,
      payload: PAGE_COUPON,
    });
  }, [appDispatch]);

  return (
    <div className={styles.main}>
      <div className={styles.title}>企業優惠</div>
      <div className={styles.desc} style={{ marginBottom: 20 }}>
        您在企業方案的優惠權益
      </div>
      <CouponContent />
    </div>
  );
};

export default Coupon;
